import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import SPForm from '../../Form/SPForm';
import editAPIcredentials from '../../Form/json/editApiCredentialsFormFields.json';
import SPFormButton from '../../Form/SPFormButton';
import {
  doFormErrorMsgs,
  getUserInfoById,
  isEmpty,
  showAPIerror
} from '../../../../pages/SellerProfile/APIs/Helpers';
import GetLabels from '../../../../pages/SellerProfile/GetLabels';
// import {
//   SpAPIgetApiCredTypes,
//   SpApiUpdateAPIcreds
// } from '../../../../pages/SellerProfile/APIs/ApiCredsAPI';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setFormLoading,setShowSuccessPopUp,setModalType, setApiStatus } from '../../../../redux/slices/sellerProfileSlice';
import { fetchCredentialTypes, setApiCredTypes, updateApiCredentialsStart, setSuccessUpdating } from '../../../../redux/slices/apiCredentialSlice';

export const EditApiCredentials = ({ curr_user_id, email }) => {
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { seller_id, users ,formLoading,spPageText,formUpdates} = useSelector((state: any) => state.sellerProfile);
  const { apiCredTypes, successUpdating, loading, apiResponse } = useSelector((state: any) => state.apiCredential);

  const credentialTypeMapping = {
    fr: 'credentials_type_fr',
    en: 'credentials_type_en'
    // Add other languages if needed
  };

  useEffect(() => {
    const updateFormFields = (credTypes) => {
      credTypes.forEach((type) => {
        const credential_type_id =
          credentialTypeMapping[i18n.language] || 'credentials_type_en';
        editAPIcredentials.env.options[type.credentials_type_en] = {
          label: type[credential_type_id],
          type: 'checkbox',
          value: type.credential_type_id
        };
      });
      setLoaded(true);
    };
    if (isEmpty(apiCredTypes)) {
      const res = dispatch(fetchCredentialTypes({ seller_id, language: i18n.language }))
      try {
        dispatch(setApiCredTypes(res));
        updateFormFields(res);
      }
      catch (res) { showAPIerror(res,setShowSuccessPopUp,setApiStatus,spPageText, 'SpAPIgetApiCredTypes') }
    }
    else {
      updateFormFields(apiCredTypes);
    }
  dispatch(setFormLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formData = getUserInfoById(users, curr_user_id);


  useEffect(() => {
    if (successUpdating) {
      const useSuccessMsg =
        apiResponse === 'removed'
          ? t('sellerProfile.dashboard.addAPIcredsSuccess')
          : t('sellerProfile.dashboard.editAPIcredsSuccess')
      const successMsg = GetLabels(useSuccessMsg, spPageText);
      dispatch(setModalType(''));
      dispatch(setShowSuccessPopUp(successMsg));
      //dispatch(fetchAllApiCredentialStart({ seller_id, language: i18n.language }))
      dispatch(setSuccessUpdating(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successUpdating]);


  const submitFormFields = async (formName: string) => {
    try {
      dispatch(updateApiCredentialsStart({
        language: i18n.language,
        formUpdates: formUpdates,
        curr_user_id,
        seller_id
      }))
    }
    catch (error: any) {
      doFormErrorMsgs(error, dispatch, spPageText);
      console.log('Error updating user api creds', error);
    }
  };

  return loaded ? (
    <Box className="editUserCardPopupContainer">
      <Box className="editUserCardPopupBody">
        <Typography className="emailDescription">
          {t('sellerProfile.dashboard.email')}:{' '}
          <span className="emailAddress">{email}</span>
        </Typography>
        <SPForm
          cols="single"
          compName="editUserCardPopupForm"
          formFields={editAPIcredentials}
          user_id={curr_user_id}
          formData={formData}
          formName="editAPIcreds"
          key="editAPIcredentials"
        />
        {!formLoading && (
          <SPFormButton
            label={t('sellerProfile.dashboard.saveUpdates')}
            compName="updateUserSettings"
            formName="editAPIcreds"
            handleClick={() => submitFormFields('editAPIcreds')}
            showLoading={loading}
          />
        )}
      </Box>
    </Box>
  ) : (
    <></>
  );
};
